import { ELocalStorageKey } from '/@/types/enums'
import { CURRENT_CONFIG } from '/@/api/http/config'
import cookies from 'vue-cookies'
import { encryptPathSegment } from '/@/api/rsa/api-crypto'

export function getWebsocketUrl () {
  const token: string = cookies.get(ELocalStorageKey.Token) || '' as string
  const url = CURRENT_CONFIG.websocketURL + '?x-auth-token=' + encryptPathSegment(encodeURI(token))
  return url
}
